export default function log (msg) {
  if (GV.config.debug) {
    console.log(msg)
  }
}




// WEBPACK FOOTER //
// ./D:/node-prj/geoviewer2/src/util/log.js